import { authConstants } from "../constants";
import { isEmpty } from "../helpers";

interface Action {
  type: string,
  user: string
};

let user = JSON.parse(localStorage.getItem("user_data") || "{}");
let onboarded = JSON.parse(localStorage.getItem("onboarded") || false);
const initialState = !isEmpty(user) && user.isEmailConfirmed ? {
  isAdmin: user.admin,
  loggedIn: true,
  user,
  onboarded: onboarded
} : { loggedIn: false };

export const authentication = (state = initialState, action: Action) => {
  switch (action.type) {
    case authConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.user
      };
    case authConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        onboarded: onboarded,
        user: action.user
      };
    case authConstants.LOGIN_FAILURE:
      return {};
    case authConstants.LOGOUT:
      return {};
    default:
      return state
  }
}
